module.exports = __webpack_public_path__ + "static/media/phone4.41f9313b.png";